import { useEffect, useRef, useState } from 'react'

/**
 * Returns a ref and a key that increments each time the ref element becomes visible.
 * Useful for forcing remount of virtualized components (e.g. antd Tree with height prop)
 * inside popups that hide/show without unmounting.
 */
export const useRemountOnVisible = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const [key, setKey] = useState(0)

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setKey(k => k + 1)
      },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return { ref, key }
}
